import { RatingsActionTypes } from '../types';
import { makeAsyncActionCreators } from '../../helpers';

const fetchRatingsByUserId = makeAsyncActionCreators(
  RatingsActionTypes.fetchRatingsByUserId,
  ['userId'],
  ['ratings'],
  ['error'],
);

const addOrUpdateRating = makeAsyncActionCreators(
  RatingsActionTypes.addOrUpdateRating,
  ['rating'],
  ['rating'],
  ['error'],
);

const changeRatingStatus = makeAsyncActionCreators(
  RatingsActionTypes.changeRatingStatus,
  ['ratingId'],
  ['rating'],
  ['error'],
);

const deleteRating = makeAsyncActionCreators(
  RatingsActionTypes.deleteRating,
  ['ratingId'],
  ['ratingId'],
  ['error'],
);

const getProjectsFeedbackData = makeAsyncActionCreators(
  RatingsActionTypes.getProjectsFeedbackData,
  ['filters', 'pagination', 'sortBy', 'ratingTypes', 'currentPath', 'onlyByWriters'],
  ['ratings'],
  ['error'],
);

const getProjectsFeedbackForExcel = makeAsyncActionCreators(
  RatingsActionTypes.getProjectsFeedbackForExcel,
  ['filters', 'sortBy', 'ratingTypes', 'tableAPI', 'onlyByWriters'],
  ['ratings'],
  ['error'],
);

export default {
  fetchRatingsByUserId,
  addOrUpdateRating,
  changeRatingStatus,
  deleteRating,
  getProjectsFeedbackData,
  getProjectsFeedbackForExcel,
};
